module.exports = __webpack_public_path__ + "img/C542.11efe33b.jpg";